/* eslint-disable */
import Vue from 'vue'
import VueRouterMiddleware from 'vue-router-middleware'
import './init'
import {Store} from "./helpers"

// Styles
import 'bootstrap/dist/css/bootstrap.css'
import '@/scss/shards-dashboards.scss'
import '@/assets/scss/date-range.scss'

// Core
import App from './App'
import router from './router'
import middlewares from './middlewares'

// Layouts
import Default from './layouts/Default'

// Mixins
import TitleMixin from './mixins/TitleMixin'
import ErrorMixin from './mixins/ErrorMixin'
import AuthMixin from './mixins/AuthMixin'


Vue.component('default-layout', Default)

Vue.mixin(TitleMixin)
Vue.mixin(ErrorMixin)
Vue.mixin(AuthMixin)

Vue.use(VueRouterMiddleware, {router, middlewares})

Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue()

new Vue({
  router,
  store: Store,
  render: h => h(App),
}).$mount('#app')
